<div class="e2e-tillatteautentiseringsmetoder">
  <h2 class="overskrift">{{ 'Tillatte innloggingsmetoder' |translate }}</h2>

@if (modus() === 'rediger') {
  <div class="skjema" data-testid="skjema-visning">
    <h4>Velg laveste innloggingsnivå </h4>
    <mat-radio-group
            class="tillatte-autentiseringsmetoder"
            [(ngModel)]="valgtInnlogging">
      @for (metode of metoder; track metode.metode) {
        <div class="tillatte-autentiseringsmetoder__valg">
          <mat-radio-button [value]="metode.metode">
            <span>
            @switch (metode.metode) {
              @case (Autentiseringsmetode.passord) {
                {{ 'Passord' | translate }}
              }
              @case (Autentiseringsmetode.totpOtp) {
                {{ 'Passord og brukernavn med engangskode fra kodegenerator' | translate }}
              }
              @case (Autentiseringsmetode.smsOtp) {
                {{ 'Passord og brukernavn med engangskode via sms' | translate }}
              }
              @case (Autentiseringsmetode.criiptoOpenId) {
                {{ 'BankID' | translate }}
              }
            }
            </span>
            @if (!brukerHarHoeyereNivaa(metode.metode)) {
              <span class="tillatte-autentiseringsmetoder__advis-ikke-aktivert">
                <mat-icon class="advarsel" >warning</mat-icon>
                {{ 'Ikke aktivert på din profil' | translate }}
              </span>
            }
          </mat-radio-button>
        </div>
      }
    </mat-radio-group>
    <div class="handling">
      <button mat-flat-button color="primary e2e-lagre" (click)="lagre()" data-testid="lagre-knapp">
        {{ 'Lagre' | translate }}
      </button>
      <button mat-button (click)="avbryt()" data-testid="avbryt-knapp">
        {{ 'Avbryt' | translate }}
      </button>
    </div>
  </div>
}

<div class="vis-metoder">
  <p class="overskrift">{{ 'For tilgang til denne gruppen må brukeren være innlogget med en av følgende metoder:' |translate }}</p>
  <div>
    <ul>
      @if (valgtMetodeStoetterPassord()) {
        <li class="">
          <div class="e2e-metode tittel">{{ 'Passord og brukernavn' |translate }}</div>
          <div class="beskrivelse">{{ 'Bruker må logge inn med brukernavn og passord.' |translate }}</div>
        </li>
      }
      @if (valgtMetodeStoetterSms()) {
        <li>
          <div class="e2e-metode tittel">{{ 'Passord og brukernavn med engangskode via sms' |translate }}</div>
          <div class="beskrivelse">{{ 'Bruker må logge inn med tofaktor-løsning bestående av brukernavn og passord samt en engangskode sendt til bruker via sms.' |translate }}</div>
        </li>
      }
      @if (valgtMetodeStoetterTotpOtp()) {
        <li class="">
          <div class="e2e-metode tittel">{{ 'Passord og brukernavn med engangskode fra kodegenerator' |translate }}</div>
          <div class="beskrivelse">{{ 'Bruker må logge inn med tofaktor-løsning bestående av brukernavn og passord samt en engangskode via en autentiseringsapp som Google Authenticator eller Microsoft Authenticator.' |translate }}</div>
        </li>
      }
      @if (valgtMetodeStoetterCriiptoOpenId()) {
        <li class="">
          <div class="e2e-metode tittel">{{ 'BankID' |translate }}</div>
          <div class="beskrivelse">{{ 'Bruker må logge inn med norsk BankID. Dette gir det høyeste sikkerhetsnivået.' |translate }}</div>
        </li>
      }
    </ul>
  </div>


  @if (kanRedigere() && modus() == 'vis') {
    <div class="handling">
      <button mat-flat-button color="primary e2e-rediger" (click)="rediger()" data-testid="rediger-knapp">
        {{ 'Endre' | translate }}
      </button>
    </div>
  }

  @if(!kanRedigere()) {
    <div>
      <span>{{ 'Kun administrator i gruppa kan redigere innloggingsmetoder.' |translate }}</span>
    </div>
  }

</div>
</div>


